import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { App } from "./App";
import { store } from "./stores/store";
import { HashRouter } from "react-router-dom";
import GlobalStyles from "./styles/Global";
import { ThemeProvider } from "styled-components";
import { theme } from "./constants/StyledComponents";
import { pdfjs } from "react-pdf";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback/ErrorBoundaryFallback.component";
import { NotificationProvider } from "./providers/notification.provider";
import { EditingProvider } from "./providers/editing.provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});
//Expose QueryClient on window for TanStack Query DevTools debugging
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
  }
}

window.__TANSTACK_QUERY_CLIENT__ = queryClient;

if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: "https://eu.i.posthog.com",
    defaults: "2026-01-30",
  });
}

const registerSW = async () => {
  if (process.env.REACT_APP_MOCKING === "true") {
    const { worker } = await import("./mocks/browser");
    return worker.start();
  }
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

//configuration worker PDF
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

registerSW().then(() => {
  root.render(
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <HashRouter>
            <ThemeProvider theme={theme}>
              <NotificationProvider>
                <EditingProvider>
                  <GlobalStyles />
                  <PostHogErrorBoundary>
                    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
                      <App />
                    </ErrorBoundary>
                  </PostHogErrorBoundary>
                </EditingProvider>
              </NotificationProvider>
            </ThemeProvider>
          </HashRouter>
        </Provider>
      </QueryClientProvider>
    </PostHogProvider>,
  );
});
